import { SETCARTCOUNT, SETCARTDATA, SETCARTTOTALPRICE, } from "../redux/features/CartData";
import { CLEARCUSTOMIZEDDATA, SETCUSTOMIZEDDATA, } from "../redux/features/CustomizedData";
import { CLEARVARIATIONDATA, SETVARIATIONDATA, } from "../redux/features/Variation";
import { CLEARMEALDATA, SETMEALDATA } from "../redux/features/MealData";
import { GetItemPrice } from "./GetItemPrice";
import { GetTotalPrice } from "./GetTotalPrice";
import { ItemCount } from "./ItemCount";
import { TaxCalcualate } from "./TaxCalculate";
import { Dispatch } from "redux";
import Konsole from "./konsole/Konsole";
import { CheckIsMeal } from "./CustomizedCalculation/MealPrice";
import { CLEARADDONDATA, SETADDONDATA } from "../redux/features/AddonsData";
import { menuselection_addon, menuselection_cutomize, menuselection_meal, menuselection_varitaion } from "../constant/constant";
import { isTaxInclusive } from "./helper";


function CheckIsVariation(data: any) {
  return data?.item_variation?.length > 0 && data?.variation_status != 0 && data?.customize_status == 0
}
function CheckIsAdOn(data: any) {
  return data?.addon_data?.length > 0 && data?.addon_status == 1 && data?.customize_status == 0 && data?.item_variation == 0
}
const AddToCart = async (
  data: any,
  item: any,
  items: any,
  disPatch: Dispatch,
  itemCount: number,
  menu_id: number,
  taxdata: any,
  setOpen: (open: boolean, type: any) => void
) => {

  disPatch(CLEARVARIATIONDATA({}));
  disPatch(CLEARCUSTOMIZEDDATA({}));
  disPatch(CLEARMEALDATA())
  disPatch(CLEARADDONDATA({}))
  if (CheckIsMeal(data?.is_meal)) {
    data['textdata_for_page'] = taxdata;
    data['menu_id_for_page'] = menu_id;
    disPatch(SETMEALDATA(structuredClone(data)));
    setOpen(true, menuselection_meal);
  } else if (CheckIsVariation(data)) {

    let item_data = { ...item }
    // @@ add text data and menu id for page
    item_data['textdata_for_page'] = taxdata;
    item_data['menu_id_for_page'] = menu_id;
    disPatch(SETVARIATIONDATA(item_data));
    setOpen(true, menuselection_varitaion);
  } else if (CheckIsAdOn(data)) {
    let item_data = { ...item }
    // @@ add text data and menu id for page
    item_data['textdata_for_page'] = taxdata;
    item_data['menu_id_for_page'] = menu_id;
    disPatch(SETADDONDATA(item_data));
    setOpen(true, menuselection_addon);
  } else if (data?.customize_status === 0) {
    // console.log("_items",items)
    Konsole.log(items);
    if (items?.length) {
      const find = items.find((d: any) => d.item_id === data.item_id);
      // console.log("_findfind",find)
      const itemPrice = GetItemPrice(data);
      if (find) {
        // let total_for_tax=parseFloat(find.sub_total)* (parseInt(find.quantity) + 1)
        const TaxData = TaxCalcualate(taxdata, parseFloat(find.sub_total)* (parseInt(find.quantity) + 1), parseInt(find.quantity || 0) + 1);
        // console.log('_tax_data',TaxData,find,total_for_tax)
        data["quantity"] = parseInt(find.quantity) + 1;
        data["selectedCategory"] = [];
        data["selectedoptions"] = [];
        data["selected_addOn"] = [];
        data["sub_total"] =find.sub_total;
        data["tax_rate_list"] = TaxData.taxArray;
        data["total_price"] = parseFloat(find.total_price) + parseFloat(itemPrice);
        data["uniqueIndex"] = find.uniqueIndex;
        data["price"] = itemPrice;
        data["menu_id"] = menu_id;
        const index = items.indexOf(find);
        items.splice(index, 1, data);
        // console.log(items,"items")
        disPatch(SETCARTDATA(items));
        disPatch(SETCARTTOTALPRICE(GetTotalPrice(items)));
        disPatch(SETCARTCOUNT(ItemCount(items)));
        sessionStorage.setItem("items", JSON.stringify(items));
      } else {
        const TaxData = TaxCalcualate(taxdata, Number(itemPrice), 1);
        data["uniqueIndex"] = items[items.length - 1]?.uniqueIndex + 1;
        data["quantity"] = 1;
        data["sub_total"] = Number(itemPrice);
        data["total_price"] = isTaxInclusive(TaxData.tax_inclusive_exclusive_type) ? Number(itemPrice) : Number(itemPrice) + TaxData.fixedTax + (Number(itemPrice) * TaxData.percentageTax) / 100;
        data["selectedCategory"] = [];
        data["selectedoptions"] = [];
        data["selected_addOn"] = [];
        data["price"] = itemPrice;
        data["menu_id"] = menu_id;
        item["map_tax_class"] = taxdata.map_tax_class;
        item["tax_class"] = taxdata.tax_class;
        data["tax_rate_list"] = TaxData.taxArray;

        items.push(data);
        disPatch(SETCARTTOTALPRICE(GetTotalPrice(items)));
        disPatch(SETCARTCOUNT(ItemCount(items)));
        disPatch(SETCARTDATA(items));
        sessionStorage.setItem("items", JSON.stringify(items));
      }
    } else {
      const itemPrice = GetItemPrice(data);
      const TaxData = TaxCalcualate(taxdata, parseFloat(itemPrice), 1);
      data["uniqueIndex"] = 1;
      data["tax_rate_list"] = TaxData.taxArray;
      data["quantity"] = 1;
      data["sub_total"] = Number(itemPrice);
      data["total_price"] = isTaxInclusive(TaxData.tax_inclusive_exclusive_type) ? Number(itemPrice) : Number(itemPrice) + TaxData.fixedTax + (Number(itemPrice) * TaxData.percentageTax) / 100;
      data["selectedCategory"] = [];
      data["selectedoptions"] = [];
      data["selected_addOn"] = [];
      data["price"] = itemPrice;
      data["menu_id"] = menu_id;
      item["map_tax_class"] = taxdata.map_tax_class;
      item["tax_class"] = taxdata.tax_class;
      disPatch(SETCARTDATA([data]));
      disPatch(SETCARTTOTALPRICE(GetTotalPrice([data])));
      disPatch(SETCARTCOUNT(ItemCount([data])));
      sessionStorage.setItem("items", JSON.stringify([data]));
    }
  } else {
    let item_data = { ...item }
    // @@ add text data and menu id for page
    item_data['textdata_for_page'] = taxdata;
    item_data['menu_id_for_page'] = menu_id;
    disPatch(SETCUSTOMIZEDDATA(item_data));
    setOpen(true, menuselection_cutomize);
  }
};

export default AddToCart;
